<template>
    <chip-line color="warning" :title="$t('label.test_mode')"/>
</template>

<script>

export default {
        name: "TestModeLine",
    }
</script>